import { navigate } from "gatsby"
import React from "react"
import { useEffect } from "react"

const Home: React.FC<{}> = () => {
  useEffect(() => {
    navigate("/app")
  }, [])

  return null
}

export default Home
